<template>
  <div class="pay-activity-page">
    <div class="circle circle1"/>
    <div class="circle circle2"/>
    <div class="btn-container">
      <wx-open-launch-weapp :path="path" username="gh_4a6788dd35cf" @launch="handleLaunch">
        <script type="text/wxtag-template">
          <div
            style=" width: 222px;height: 42px;text-align: center; line-height: 42px;font-size: 20px;font-weight: 700;letter-spacing: 5px; color: #05993C;">
            我要报名
          </div>
        </script>
      </wx-open-launch-weapp>
    </div>
  </div>
</template>

<script>
import { api } from '@/api/index'
import { Public } from '@/utils/public'
import { TOOL } from '@/utils/tool'
import wx from 'weixin-js-sdk'

export default {
  name: "PayActivity",
  data() {
    return {
      schoolId: '',
      sceneNum: '', // 场景值
      path: '',
      openId: ''
    }
  },
  created() {
    this.schoolId = this.$route.query.schoolId
    this.sceneNum = this.$route.query.sceneNum
    this.openId = this.$route.query.openId
    this.getConfig()
    wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
      //隐藏右上角菜单接口
      wx.hideOptionMenu()
      // 隐藏所有基础类
      // wx.hideAllNonBaseMenuItem()
    })
    this.fetchData()
    Public.ReportBuryingPoint({
      wxEventType: 2,
      wxSource: 1,
      openType: 1,
      openId: this.openId,
      pageUrl: '/activity/payActivity'
    }).then(res => {
      console.log('reportSuccess', res)
    }).catch(err => {
      console.log('reportError', err)
    })
    if (TOOL.IsWechat()) {
      if (!TOOL.CompareVersion(TOOL.WechatVersion(), '7.0.12')) {
        this.$dialog.alert({
          message: '当前微信版本过低\n请先升级微信版本再来体验哦~'
        })
      } else {
        if (TOOL.IsIos()) {
          if (!TOOL.CompareVersion(TOOL.GetIosVersion(), '10.3')) {
            this.$dialog.alert({
              message: '当前手机系统版本过低\n请先升级系统版本再来体验哦~'
            })
          }
        } else if (TOOL.IsAndroid()) {
          if (!TOOL.CompareVersion(TOOL.GetAndroidVersion(), '5.0')) {
            this.$dialog.alert({
              message: '当前手机系统版本过低\n请先升级系统版本再来体验哦~'
            })
          }
        }
      }
    } else {
      this.$dialog.alert({
        message: '请切换至微信内打开访问哦~'
      })
    }
  },
  methods: {
    fetchData() {
      api.getActivityPayDetail({
        schoolId: this.schoolId,
        sceneNum: this.sceneNum
      }).then(res => {
        if (res.code === 10000) {
          this.path = res.data.content + '?schoolId=' + res.data.schoolId + '&openId=' + this.openId + '&enterType=activity'
          document.title = res.data.schoolName
        } else {
          this.$toast.fail(res.message)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getConfig() {
      api.getPublicConfig({
        url: window.location.href
      }).then(res => {
        if (res.code === 10000) {
          wx.config({
            "debug": false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            "appId": 'wxdf0bb6a6a966ecd5', // 必填，公众号的唯一标识
            "timestamp": res.data.timestamp, // 必填，生成签名的时间戳
            "nonceStr": res.data.noncestr, // 必填，生成签名的随机串
            "signature": res.data.signature,// 必填，签名
            "jsApiList": ['hideOptionMenu', 'hideAllNonBaseMenuItem'], // 必填，需要使用的JS接口列表
            "openTagList": ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
          })
        } else {
          this.$toast.fail(res.message)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleLaunch() {
      Public.ReportBuryingPoint({
        wxEventType: 3,
        wxSource: 1,
        openType: 1,
        openId: this.openId,
        pageUrl: '/activity/payActivity'
      }).then(res => {
        console.log('reportSuccess', res)
      }).catch(err => {
        console.log('reportError', err)
      })
    }
  }
}
</script>

<style scoped>
.pay-activity-page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #5bb97c;
  background-image: url("../../assets/img/pay-activity-bg.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  overflow: hidden;
}

.circle {
  position: absolute;
  background-color: rgba(125, 209, 96, .25);
  border-radius: 50%;
  z-index: 0;
}

.circle1 {
  width: 220px;
  height: 220px;
  left: -100px;
  bottom: -100px;
}

.circle2 {
  width: 200px;
  height: 200px;
  right: -100px;
  bottom: -100px;
}

.btn-container {
  position: absolute;
  top: 520px;
  left: 50%;
  transform: translateX(-50%);
  width: 222px;
  height: 42px;
  background-color: #FFF03B;
  border-radius: 21px;
  z-index: 9;
  text-align: center;
  box-shadow: 0 5px 1px rgba(255, 189, 74, .7);
}
</style>